import { intlFormat, parseISO } from "date-fns";
import useTimeZone from "helpers/useTimeZone";
import React from "react";

function getOrdinal(day) {
  if (day >= 11 && day <= 13) {
    return `${day}th`;
  }
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}

function formatTimeWeekdayDate(date, timeZone) {
  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone,
  });
  const dateFormatter = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone,
  });
  const compactTime = timeFormatter.format(date).replace(/\s/g, "").toLowerCase();
  const parts = dateFormatter.formatToParts(date);
  const weekday = parts.find((part) => part.type === "weekday")?.value;
  const day = Number(parts.find((part) => part.type === "day")?.value || 0);
  const month = parts.find((part) => part.type === "month")?.value;
  const year = parts.find((part) => part.type === "year")?.value;
  return `${compactTime}, ${weekday} ${getOrdinal(day)} ${month} ${year}`;
}

export default function DateTime({ value, variant, defaultValue = "?", ...others }) {
  const timeZone = useTimeZone();
  const parsedValue = value ? parseISO(value) : null;
  const formatOptions = {
    time: {
      timeStyle: "medium",
    },
    date: {
      dateStyle: "long",
    },
    short_date: {
      month: "short",
      day: "numeric",
    },
    month: {
      month: "short",
      year: "numeric",
    },
  };
  const fallbackOptions = {
    timeStyle: "short",
    dateStyle: "long",
    hour12: true,
    weekday: "short",
  };

  return (
    <span title={timeZone} {...others}>
      {!value && defaultValue}
      {parsedValue &&
        (variant === "time_weekday_date"
          ? formatTimeWeekdayDate(parsedValue, timeZone)
          : intlFormat(parsedValue, {
              ...(formatOptions[variant] || fallbackOptions),
              timeZone,
            }))}
    </span>
  );
}
